import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isSponsoredAccountAndDimension } from '../../../../../config/report-predicates/isSponsoredAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { CATEGORY_REPORT_ID } from './categoryReportId';
import columnDefinitions from './columnDefinitions';
import { customColumns, defaultColumns } from './reportPresets';

export const categoryReportConfig = {
    id: CATEGORY_REPORT_ID,
    label: 'Categories',
    permissions: [REPORT_PERMISSION.ADS_CONSOLE_CATEGORY_REPORT],
    accountConfigurations: { [FEATURE_FLAGS.SHOW_CATEGORY_REPORT]: 'true' },
    visibilityCondition: isSponsoredAccountAndDimension,
    mudule: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-category',
    rowIdField: FIELDS.CATEGORY.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    searchPlaceholderMsgId: 'app.reports.byCategory.search.placeholder',
    searchField: FIELDS.CATEGORY.field,
};

export default categoryReportConfig;
